<template>
    <div class="applyList">
        <div class="nav">
            <router-link to="/pilotage" tag="span">领航研服务</router-link>
            <router-link to="/pilotagelist"  tag="span" class="active">案例库</router-link>
        </div>
        <!-- banner -->
        <div class="banner">
            <div class="img"><img src="@/assets/img/pilotage/ggu_logo.png" alt=""></div>
            <p>领航研部分成功案例</p>
        </div>
        <!-- list -->
        <div class="apply_list">
            <ul class="wrap">
                <li class="apply_li" v-for="(item,index) in applyData" :key="index">
                    <div class="top" :style="'background:'+item.background">
                        <div class="school">
                            <p class="school_name">{{item.e_apply_school}}</p>
                            <p class="enter">{{item.c_apply_school}}</p>
                        </div>
                        <img :src="item.logo" alt="">
                    </div>
                    <div class="bottom">
                        <p class="p_title">{{item.name}}同学</p>
                        <p class="language">本科：{{item.school}}</p>
                        <p class="language">初试总分：{{item.language_achievement}}</p>
                        <div class="info">
                            考研结果<span>|</span>{{item.admission_results}}
                        </div>
                    </div>
                </li>
                <div class="loading" v-if="!applyData.length">
                    <van-loading type="spinner" color="#05c9d3" />
                </div>
            </ul>
        </div>
    </div>
</template>

<script>

import api from "@/api/apply";
export default {
    data() {
        return {
            dataImgUrl:"http://www.gguconsulting.com/try/sbm/Public/GGUExper_files/",
            applyData:[{
                admission_results: "2020年清华大学经济管理学院 金融硕士",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "380（全国前十）",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "Monica",
                school: "上海某211院校(经管类非金融专业，一战考研)"
            },{
                admission_results: "2018年清华美院 艺术硕士",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "380分 (全国第一)",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "Y",
                school: "南方某高校新闻学专业(无绘画经验，一战跨考)"
            },{
                admission_results: "2018年清华美院 艺术硕士",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "379分 (全国第二)",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "X",
                school: "北方某双非院校(本科教学落后，一战考研)"
            },{
                admission_results: "2020年清华大学环境学院 环境科学与工程",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "350+（其中专业课120+）",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "小欣",
                school: "西北某985院校资源与环境经济学专业(信息匮乏，本科学习方向偏管理)"
            },{
                admission_results: "2019年清华大学精仪系 仪器科学与技术硕士",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "370（其中专业课二145+，全国前三）",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "天天",
                school: "天津某双非院校(机械工程专业，二战考研)"
            },{
                admission_results: "2019年清华美院 艺术硕士",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "347分 (其中美术理论专业第二名)",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "L",
                school: "北方某院校美术类专业(手绘功底差，一战考研)"
            },{
                admission_results: "2020年清华大学法学院 法律硕士(非法学)",
                background: "#7C309C",
                c_apply_school: "清华大学",
                e_apply_school: "Tsinghua University",
                language_achievement: "387分",
                logo: require("@/assets/img/pilotage/qing.png"),
                name: "W",
                school: "天津某211院校理科专业(一战跨考)"
            },{
                admission_results: "2020年北大汇丰商学院 金融专硕",
                background: "#9E0000",
                c_apply_school: "北京大学",
                e_apply_school: "Beijing University",
                language_achievement: "398分（复试专业前三）",
                logo: require("@/assets/img/pilotage/bei.png"),
                name: "S",
                school: "上海某高校工科经济学双学位(一战跨考)"
            },{
                admission_results: "2020年北大国家发展研究院 理论经济学(国家发展)硕士",
                background: "#9E0000",
                c_apply_school: "北京大学",
                e_apply_school: "Beijing University",
                language_achievement: "380+（复试为专业第二名）",
                logo: require("@/assets/img/pilotage/bei.png"),
                name: "子墨",
                school: "北方某财经类双非大学(二战考研)"
            },{
                admission_results: "2020年复旦大学新闻学院 新闻与传播专硕",
                background: "#d5271c",
                c_apply_school: "复旦大学",
                e_apply_school: "Fudan University",
                language_achievement: "384分",
                logo: require("@/assets/img/pilotage/fudan.png"),
                name: "P",
                school: "中部某双非院校中文专业(一战，跨专业考研)"
            },{
                admission_results: "2019年复旦大学临床医学院 临床医学硕士",
                background: "#d5271c",
                c_apply_school: "复旦大学",
                e_apply_school: "Fudan University",
                language_achievement: "414分",
                logo: require("@/assets/img/pilotage/fudan.png"),
                name: "Nick",
                school: "东北某医学类二本临床医学专业(全院历史第一个考上复旦的同学)"
            },{
                admission_results: "2020年上海交通大学 电气工程专业",
                background: "#133784",
                c_apply_school: "上海交通大学",
                e_apply_school: "Shanghai Jiao Tong University",
                language_achievement: "365+",
                logo: require("@/assets/img/pilotage/shangjiao.png"),
                name: "QW",
                school: "武汉理工大学电气工程专业(基础较差，跨校考研)"
            },{
                admission_results: "2020年上海交通大学国务学院 公共管理专业",
                background: "#133784",
                c_apply_school: "上海交通大学",
                e_apply_school: "Shanghai Jiao Tong University",
                language_achievement: "409分（初试综排前十）",
                logo: require("@/assets/img/pilotage/shangjiao.png"),
                name: "阿信",
                school: "华中师范大学社会学专业(跨校跨专业考研)"
            },{
                admission_results: "2020年中国人民大学商学院 会计专硕",
                background: "#81221E",
                c_apply_school: "中国人民大学",
                e_apply_school: "Renmin University of China",
                language_achievement: "239分",
                logo: require("@/assets/img/pilotage/ren.png"),
                name: "T",
                school: "中部某211院校财务管理专业(基础相对薄弱)"
            },{
                admission_results: "2020年中国人民大学财金学院 金融学硕士",
                background: "#81221E",
                c_apply_school: "中国人民大学",
                e_apply_school: "Renmin University of China",
                language_achievement: "388分",
                logo: require("@/assets/img/pilotage/ren.png"),
                name: "SSR",
                school: "山东财经大学工商管理专业(基本没学过金融知识)"
            },{
                admission_results: "2020年北京航空航天大学机械学院 机械工程硕士",
                background: "#025098",
                c_apply_school: "北京航空航天大学",
                e_apply_school: "Beihang University",
                language_achievement: "358分",
                logo: require("@/assets/img/pilotage/beihang.png"),
                name: "Jerry",
                school: "西部某工科985机械工程专业(签约前对北航备考一无所知)"
            },{
                admission_results: "2019年南开大学计算机学院 计算机技术硕士",
                background: "#801e68",
                c_apply_school: "南开大学",
                e_apply_school: "Nankai University",
                language_achievement: "375+",
                logo: require("@/assets/img/pilotage/nankai.png"),
                name: "DD",
                school: "河北工业大学软件工程专业(学生会骨干，专业成绩较差)"
            },{
                admission_results: "2020年西南财经大学金融学院 金融学硕士",
                background: "#0077bd",
                c_apply_school: "西南财经大学",
                e_apply_school: "Southwestern University Of Finance And Economics",
                language_achievement: "370分（复试90+，专业排名前三）",
                logo: require("@/assets/img/pilotage/xicai.png"),
                name: "小世",
                school: "东北财经大学保险学专业(放弃内保，选择跨专业考研)"
            },{
                admission_results: "2019年西安交通大学 细胞生物学硕士",
                background: "#c92b2f",
                c_apply_school: "西安交通大学",
                e_apply_school: "Xi’an Jiaotong University",
                language_achievement: "374分",
                logo: require("@/assets/img/pilotage/xijiao.png"),
                name: "澜澜",
                school: "陕西师范大学生物科学专业(本科GPA2.8，基础薄弱)"
            },{
                admission_results: "2020年中南大学马克思主义学院 思想政治教育硕士",
                background: "#217aad",
                c_apply_school: "中南大学",
                e_apply_school: "Central South University",
                language_achievement: "367分",
                logo: require("@/assets/img/pilotage/zhongnan.png"),
                name: "阿雅",
                school: "广东某二本院校商务英语专业(跨专业考研)"
            },{
                admission_results: "2020年郑州大学 法律硕士(非法学)",
                background: "#005843",
                c_apply_school: "郑州大学",
                e_apply_school: "Zhengzhou University",
                language_achievement: "401分（专业第一）",
                logo: require("@/assets/img/pilotage/zheng.png"),
                name: "FR",
                school: "河南科技大学工商管理专业(跨专业考研)"
            }]
        }
    },
    methods:{
        //获取offer数据
        async getApplyData(){
            try {
                let re = await api.apply_undergraduate_list();
                this.applyData = re.data.data.list;
                console.log(this.applyData,1111)
            } catch (error) {
                console.error(error);
            }
        }
    },
    created(){
        // this.getApplyData();
    }
}
</script>

<style lang="less" scoped>
.applyList {
    background:#fff;
    // font-family: 'PingFang Regular';

    //nav
    .nav {
        height: 90px;
        border-bottom: 1px solid #E6E6E6;

        span {
            font-size: 32px;
            color: #192533;
            width: 50%;
            text-align: center;
            line-height: 90px;
            display: inline-block;
            font-weight: 600;
        }
        .active {
            color: #da1f1f;
            position: relative;
        }
        .active:before {
            border-bottom: 5px solid #da1f1f;
            bottom: 0;
            content: "";
            display: inline-block;
            left: calc(50% - 25px);
            position: absolute;
            width: 50px;
        }
    }
    .banner {
        width: 100%;
        height: 360px;
        position: relative;
        background:url("../../assets/img/pilotage/applyList_banner.jpg") no-repeat;
        p {
            padding-top: 125px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #da1f1f;
            }
        }
        .img {
            width: 170px;
            // height: 38px;
            position: absolute;
            top: 40px;
            left: 43px;
            img {
                width: 100%;
                // height: 100%;
            }
        }
    }
    .apply_list{
        padding:0 25px 100px;
        ul {
            margin-top: -115px;
            position: relative;
            li {
                margin-bottom: 30px;
                .top {
                    width: 100%;
                    height: 120px;
                    color: #fff;
                    font-weight: bold;
                    padding-left: 25px;
                    box-sizing: border-box;
                    border-radius:20px 20px 0px 0px;
                    display: flex;
                    overflow: hidden;
                    .school {
                        flex: 1;
                        padding: 25px 0;
                        .school_name {
                            width:550px;
                            font-size: 26px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .enter {
                            font-size: 24px;
                            font-style: italic;
                            margin-top: 5px;
                        }
                    }
                    img {
                        float: right;
                        width: auto;
                        height: 100px;
                        margin:10px 10px 0 0;
                    }
                }
                .bottom {
                    border: 1px solid rgba(204, 204, 204, 1);
                    border-top: none;
                    border-radius: 0 0 20px 20px;
                    padding-top: 30px;
                    .p_title {
                        font-size: 30px;
                        color: #000; 
                        font-weight: bold;
                        text-align: center;
                        margin-bottom:10px;
                    }
                    .language {
                        margin-top: 10px;
                        font-size: 26px;
                        color: #666666;
                        padding:0 20px;
                    }
                    .info {
                        margin-top: 30px;
                        background: #F5F5F5;
                        position: relative;
                        padding:25px 20px;
                        font-size: 28px;
                        color: #020202;
                        border-radius: 0 0 20px 20px;
                        font-weight: 600;
                        span{
                            margin:0 10px;
                        }
                    }
                }
            }
        }
    }
    .loading{
        text-align: center;
        height:200px;
        .van-loading{
            width:100%;
            margin-top:200px;
            color:#000 !important;
        }
    }
}
</style>